import { render } from "./LiveAttendanceLoader.vue?vue&type=template&id=0d261ea0"
import script from "./LiveAttendanceLoader.vue?vue&type=script&lang=js"
export * from "./LiveAttendanceLoader.vue?vue&type=script&lang=js"

import "./LiveAttendanceLoader.vue?vue&type=style&index=0&id=0d261ea0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__